import(/* webpackMode: "eager" */ "/codebuild/output/src2672261643/src/auto-playlist/frontend/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/codebuild/output/src2672261643/src/auto-playlist/frontend/src/app/providers.tsx");
